// extracted by mini-css-extract-plugin
export default {"photoTable":"MissionPhotos_photoTable__8mQYO","photoId":"MissionPhotos_photoId__6m7ba","exifTable":"MissionPhotos_exifTable__5+3U-","problem":"MissionPhotos_problem__kMOhg"};